import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { forgetPasswordSchema } from '../validation/Validate';
import { Link } from 'react-router-dom';
import loginPic from '../assets/images/log.svg';
import { forgotPasswordAuth } from '../reducers/AuthSlice';

const ForgetPassword = () => {
    const dispatch = useDispatch();
    const { isLoading, error, successMessage } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: forgetPasswordSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setLoading(true);
            try {
                await dispatch(forgotPasswordAuth(values.email));
                formik.resetForm();
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
                setSubmitting(false);
            }
        },
    });

    return (
        <>
            <div className="containerq">
                <div className="forms-container">
                    <div className="signin-signup">
                        <form className="sign-in-form" onSubmit={formik.handleSubmit}>
                            <h2 className="title">AK Boys Hostel</h2>

                            <div className="input-field">
                                <i className="fa fa-envelope"></i>
                                <input
                                    type="text"
                                    placeholder="Email"
                                    name="email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                            {formik.touched.email && formik.errors.email && (
                                <div className="error-message m-0 text-center">{formik.errors.email}</div>
                            )}

                            {error && <div className="error-message text-center">{error.message || JSON.stringify(error)}</div>}
                            {successMessage && <div className="success-message text-center">{successMessage.message || JSON.stringify(successMessage)}</div>}

                            <div className="text-center d-flex justify-content-end">
                                <button
                                    type="submit"
                                    className="btn btn-primary text-white"
                                    disabled={loading || isLoading}
                                >
                                    {loading || isLoading ? (
                                        <span>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Sending...
                                        </span>
                                    ) : (
                                        'Submit'
                                    )}
                                </button>
                            </div>
                            <Link to='/Sign-in'>Sign In</Link>
                        </form>
                    </div>
                </div>

                <div className="panels-container">
                    <div className="panel left-panel">
                        <img src={loginPic} className="image" alt="Login" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgetPassword;
